// Design system imports
import { Divider } from '@mui/material'

const FullScreenDivider = ({ color }: { color: string }) => {
  return <Divider color={color} sx={{ position: 'absolute', width: '100%', left: 0 }} />
}

export default FullScreenDivider
